import React from 'react';
import { Link } from 'react-router-dom';
import Avatar from '../../../assets/images/profile.png'; 
import { getUserInfo, removeTokens} from '../../../utils/token';

const ProfileDropdown = () => {
  const user = getUserInfo();
  const handleLogout = async () => {
    // logout from api too

    removeTokens(); 
    window.location.reload();
  }

  return (
    <div className="dropdown ms-sm-3 header-item topbar-user">
      <button
        type="button"
        className="btn"
        id="page-header-user-dropdown"
        data-bs-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <span className="d-flex align-items-center">
          <img
            className="rounded-circle header-profile-user"
            src={Avatar}
            alt="Header Avatar"
          />
          <span className="text-start ms-xl-2">
            <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
              {user?.name}
            </span>
            <span className="d-none d-xl-block ms-1 fs-12 user-name-sub-text">
              {user?.role}
            </span>
          </span>
        </span>
      </button>
      <div className="dropdown-menu dropdown-menu-end">
        <h6 className="dropdown-header">Welcome {user?.name}!</h6>
        <Link className="dropdown-item" to="/profile">
          <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
          <span className="align-middle">Profile</span>
        </Link>
        <div className="dropdown-divider"></div>
        {user?.credit && (
        <Link className="dropdown-item" to="/wallet">
          <i className="mdi mdi-wallet text-muted fs-16 align-middle me-1"></i>
          <span className="align-middle">Credit: <b>{user?.credit}</b></span>
        </Link> 
        )}
        {/*
        <Link className="dropdown-item" to="/settings">
          <span className="badge bg-success-subtle text-success mt-1 float-end">New</span>
          <i className="mdi mdi-cog-outline text-muted fs-16 align-middle me-1"></i>
          <span className="align-middle">Settings</span>
        </Link>
        */}
        <Link className="dropdown-item" onClick={handleLogout}>
          <i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>
          <span className="align-middle">Logout</span>
        </Link>
      </div>
    </div>
  );
};

export default ProfileDropdown;